/**
 * Resolves the configured parallax speed for a CMS-supplied offset value, preserving the offset's
 * sign. Returns `null` when no offset is configured (parallax disabled).
 * @param offset - The CMS offset value; `0`, `undefined`, and `null` disable parallax.
 * @param offsetMap - Map of `|offset|` → speed magnitude.
 * @returns Signed parallax speed, or `null` when parallax is disabled.
 * @category Utils
 */
export const getParallaxSpeed = (
  offset: number | undefined,
  offsetMap: Record<any, any>
): number | null => {
  if (!offset || offset === 0) return null
  const speed = offsetMap[Math.abs(offset)]
  return offset > 0 ? speed : -speed
}
